import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Name', prop: 'name' },
  { title: 'Created', prop: 'created_at', format: 'dateWithDay' }
]

const filters = []

const defaults = {
  order: [{ column: 'name', direction: 'asc' }]
}

const ResourceCategories = (props) => (
  <List
    title='Resource Categories'
    apiPath='admin/resource_categories'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
  />
)

export default ResourceCategories
